import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import { DashboardItemComponent } from './components/dashboard/dashboard-item/dashboard-item.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ConfirmAdditionalSpaceAuthorizationComponent } from './components/select-space/confirm-additional-space-authorization/confirm-additional-space-authorization.component';
import { SelectSpaceComponent } from './components/select-space/select-space.component';
import { SpaceAccessBlockedDialogComponent } from './components/select-space/space-access-blocked-dialog/space-access-blocked-dialog.component';
import { SpaceAccessForbiddenDialogComponent } from './components/space-access-forbidden-dialog/space-access-forbidden-dialog.component';
import { TopNavigationAppSwitcherComponent } from './components/top-navigation/top-navigation-app-switcher/top-navigation-app-switcher.component';
import { TopNavigationComponent } from './components/top-navigation/top-navigation.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { MobileSignInModule } from '../../shared/modules/mobile-sign-in/mobile-sign-in.module';
import { TwoFactorModule } from '../../shared/modules/two-factor/two-factor.module';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PplComponentsAsyncViewModule } from '@ppl/components/async-view';
import { PplAddressbookModule } from '@ppl/ui/addressbook-picture';
import { PplButtonModule } from '@ppl/ui/button';
import { PplCheckboxModule } from '@ppl/ui/checkbox';
import { PplContentBlockModule } from '@ppl/ui/content-block';
import { PplFormModule } from '@ppl/ui/form';
import { PplIconModule } from '@ppl/ui/icon';
import { PplInputModule } from '@ppl/ui/input';
import { PplLoadingModule } from '@ppl/ui/loading';
import { PplPopoverModule } from '@ppl/ui/popover';
import { PplPopoverWindowModule } from '@ppl/ui/popover-window';
import { PplSelectModule } from '@ppl/ui/select';
import { PplSlideToggleModule } from '@ppl/ui/slide-toggle';
import { PplTopBarModule } from '@ppl/ui/top-bar';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardItemComponent,
    UserProfileComponent,
    SelectSpaceComponent,
    TopNavigationComponent,
    SpaceAccessForbiddenDialogComponent,
    TopNavigationAppSwitcherComponent,
    AccountComponent,
    ConfirmAdditionalSpaceAuthorizationComponent,
    SpaceAccessBlockedDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    PplTopBarModule,
    PplIconModule,
    PplInputModule,
    PplFormModule,
    PplCheckboxModule,
    PplLoadingModule,
    PplButtonModule,
    PplSelectModule,
    PplAddressbookModule,
    PplPopoverModule,
    PplPopoverWindowModule,
    PplContentBlockModule,
    PplSlideToggleModule,
    PplComponentsAsyncViewModule,
    TwoFactorModule,
    MobileSignInModule,
    AccountRoutingModule
  ]
})
export class AccountModule { }
